module.exports = __webpack_public_path__ + "img/bitcoin.280f309c.svg";